<template>
  <v-footer inset app absolute class="hidden-print">
    <!-- 普通屏幕尺寸 -->
    <v-row no-gutters class="d-none d-sm-flex my-n1">
      <span class="px-1"> {{ $t("company") }} &copy; </span>
      <span class="px-1">
        <a target="_blank" href="http://beian.miit.gov.cn/">
          沪ICP备12041198号
        </a>
      </span>
      <span class="px-1">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502011513"
        >
          <v-img
            :src="require('./assets/beianicon.png')"
            height="16"
            width="16"
            class="float-left"
          />沪公网安备31011502011513号
        </a>
      </span>
    </v-row>
    <!-- 手机小屏幕 -->
    <v-tooltip top open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-row no-gutters v-bind="attrs" v-on="on" class="d-flex d-sm-none">
          <span class="px-1" style="font-size: 8px">
            {{ $t("company") }} &copy;
          </span>
          <span class="px-1" style="font-size: 8px">
            <a target="_blank" href="http://beian.miit.gov.cn/">
              沪ICP备12041198号
            </a>
          </span>
          <span class="px-1" style="font-size: 8px">
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502011513"
            >
              <v-img
                :src="require('./assets/beianicon.png')"
                height="16"
                width="16"
                class="float-left"
              />沪公网安备
            </a>
          </span>
        </v-row>
      </template>
      <span>
        {{ $t("company") }} &copy; 2016 - {{ new Date().getFullYear() }}<br />
        沪ICP备12041198号<br />
        <v-img
          :src="require('./assets/beianicon.png')"
          height="20"
          width="20"
          class="float-left"
        />沪公网安备31011502011513号
      </span>
    </v-tooltip>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<i18n>
{
  "zhHans": {
    "company": "一言为订"
  },
  "en": {
    "company": "YYWD"
  }
}
</i18n>